<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2021 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<ng-container>
    <div class="{{klass}} float-right action-group-menu" #container>
        <ng-container *ngIf="!inlineConfirmationEnabled() && !loading()">
            <scrm-button-group *ngIf="config$" [config$]="config$" [klass]="buttonGroupClass"></scrm-button-group>
        </ng-container>
        <ng-container *ngIf="inlineConfirmationEnabled() && !loading()">
            <div class="d-flex align-items-start justify-content-end inline-confirmation">
                <div *ngIf="confirmationLabel" class="pl-1 inline-confirmation-label">
                    <scrm-label [labelKey]="confirmationLabel"></scrm-label>
                </div>
                <div *ngIf="confirmationDynamicLabel && !confirmationLabel" class="pl-1 inline-confirmation-label">
                    <scrm-dynamic-label [labelKey]="confirmationDynamicLabel"
                                        [module]="actionContext?.module ?? ''"
                                        [fields]="actionContext?.record?.fields ?? {}"
                    >
                    </scrm-dynamic-label>
                </div>
                <div *ngIf="inlineCancelButton" class="pl-1 inline-confirmation-button">
                    <scrm-button [config]="inlineCancelButton"></scrm-button>
                </div>
                <div *ngIf="inlineConfirmButton" class="pl-1 inline-confirmation-button">
                    <scrm-button [config]="inlineConfirmButton"></scrm-button>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="loading()">
            <scrm-inline-loading-spinner klass="inline-spinner-md"></scrm-inline-loading-spinner>
        </ng-container>
    </div>
</ng-container>
